<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16shFWQ/tc-custom/FC-9781645367987.png?1684515369650?1725650027065" alt="This image is the cover for the book The Wondrous Apothecary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Wondrous Apothecary
      </h1>
      <p class="bookDescription body article font2">
        <p>Follow the paths of two artists, Alexander Wainwright and Rinaldo, in a passionate, suspenseful tale of art, life, love, and liberation. For such different men in their art and personalities, the fundamental question is whether they can ever collaborate on a project.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary E. Martin
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:.0001pt;margin-left:0mm;font-size:15px;font-family:"Calibri","sans-serif";text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman","serif";'>After thirty years of law practice, Mary E. Martin embarked on her writing career. Inspired by her experiences in the law, she wrote the highly acclaimed <em>Osgoode Trilogy</em> about a lawyer named Harry Jenkins. Turning to her greatest passion, art, she then began <em>The Trilogy of Remembrance,</em> featuring a visionary landscape artist, Alexander Wainwright. <em>The Wondrous Apothecary</em> is a natural and exciting addition to that trilogy. She lives in Toronto with her husband. They have three children and three grandchildren.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?072dca6c